<ng-container *transloco="let t">
    <form class="flex flex-col items-start gap-y-24 pt-8 pb-24 sm:pb-8" #termsForm="ngForm" (ngSubmit)="submit()">
        <vds-checkbox name="termsAccepted" #termsAcceptedChkBox="ngModel" ngModel required>
            {{ t("voTextAcceptLabel") }}
        </vds-checkbox>
        <div class="flex items-center gap-x-16">
            <button vds-button appearance="primary" type="submit" [disabled]="disabled()" [loading]="updating()">
                {{ t("continue") }}
            </button>
            @if (termsForm.submitted && termsAcceptedChkBox.errors) {
                <div class="flex items-center gap-x-8 rounded-sm border border-alert-light bg-alert-transparent px-12 py-[6px]">
                    <vds-icon class="text-alert-bold" name="info" />
                    <vds-error>{{ t("acceptTermsError") }}</vds-error>
                </div>
            }
        </div>
    </form>
</ng-container>
